import __pb_dep_0 from "google-protobuf";
import __pb_dep_1 from "./IM.BaseDefine_pb.js";

const __pbDeps = {
  "google-protobuf": __pb_dep_0,
  "./IM.BaseDefine_pb.js": __pb_dep_1,
};

const __pbModule = { exports: {} };
const exports = __pbModule.exports;
const module = __pbModule;

const require = (specifier) => {
  const resolved = __pbDeps[specifier];
  if (!resolved) {
    throw new Error(`Unsupported protobuf dependency in IM.Buddy_pb.js: ${specifier}`);
  }
  return resolved;
};

(function runGeneratedProtobufModule() {
  const root = globalThis;
  root.proto ??= {};
  var proto = root.proto;
  var COMPILED = false;

// source: IM.Buddy.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();
var IM_BaseDefine_pb = require('./IM.BaseDefine_pb.js');
goog.object.extend(proto, IM_BaseDefine_pb);
goog.exportSymbol('proto.IM.Buddy.IMPCLoginStatusNotify', null, global);
goog.exportSymbol('proto.IM.Buddy.IMRecentContactSessionReq', null, global);
goog.exportSymbol('proto.IM.Buddy.IMRecentContactSessionRsp', null, global);
goog.exportSymbol('proto.IM.Buddy.IMRemoveSessionNotify', null, global);
goog.exportSymbol('proto.IM.Buddy.IMRemoveSessionReq', null, global);
goog.exportSymbol('proto.IM.Buddy.IMRemoveSessionRsp', null, global);
goog.exportSymbol('proto.IM.Buddy.IMUserStatNotify', null, global);
goog.exportSymbol('proto.IM.Buddy.IMUsersStatReq', null, global);
goog.exportSymbol('proto.IM.Buddy.IMUsersStatRsp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMRecentContactSessionReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Buddy.IMRecentContactSessionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMRecentContactSessionReq.displayName = 'proto.IM.Buddy.IMRecentContactSessionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMRecentContactSessionRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Buddy.IMRecentContactSessionRsp.repeatedFields_, null);
};
goog.inherits(proto.IM.Buddy.IMRecentContactSessionRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMRecentContactSessionRsp.displayName = 'proto.IM.Buddy.IMRecentContactSessionRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMUserStatNotify = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Buddy.IMUserStatNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMUserStatNotify.displayName = 'proto.IM.Buddy.IMUserStatNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMRemoveSessionReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Buddy.IMRemoveSessionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMRemoveSessionReq.displayName = 'proto.IM.Buddy.IMRemoveSessionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMRemoveSessionRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Buddy.IMRemoveSessionRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMRemoveSessionRsp.displayName = 'proto.IM.Buddy.IMRemoveSessionRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMUsersStatReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Buddy.IMUsersStatReq.repeatedFields_, null);
};
goog.inherits(proto.IM.Buddy.IMUsersStatReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMUsersStatReq.displayName = 'proto.IM.Buddy.IMUsersStatReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMUsersStatRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Buddy.IMUsersStatRsp.repeatedFields_, null);
};
goog.inherits(proto.IM.Buddy.IMUsersStatRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMUsersStatRsp.displayName = 'proto.IM.Buddy.IMUsersStatRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMPCLoginStatusNotify = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Buddy.IMPCLoginStatusNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMPCLoginStatusNotify.displayName = 'proto.IM.Buddy.IMPCLoginStatusNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Buddy.IMRemoveSessionNotify = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Buddy.IMRemoveSessionNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Buddy.IMRemoveSessionNotify.displayName = 'proto.IM.Buddy.IMRemoveSessionNotify';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMRecentContactSessionReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMRecentContactSessionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRecentContactSessionReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            latestUpdateTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMRecentContactSessionReq}
 */ proto.IM.Buddy.IMRecentContactSessionReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMRecentContactSessionReq;
    return proto.IM.Buddy.IMRecentContactSessionReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMRecentContactSessionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMRecentContactSessionReq}
 */ proto.IM.Buddy.IMRecentContactSessionReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLatestUpdateTime(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMRecentContactSessionReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMRecentContactSessionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRecentContactSessionReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getLatestUpdateTime();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRecentContactSessionReq} returns this
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 latest_update_time = 2;
 * @return {number}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.getLatestUpdateTime = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRecentContactSessionReq} returns this
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.setLatestUpdateTime = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Buddy.IMRecentContactSessionReq} returns this
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Buddy.IMRecentContactSessionReq} returns this
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMRecentContactSessionReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Buddy.IMRecentContactSessionRsp.repeatedFields_ = [
    2
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMRecentContactSessionRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMRecentContactSessionRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRecentContactSessionRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            contactSessionListList: jspb.Message.toObjectList(msg.getContactSessionListList(), IM_BaseDefine_pb.ContactSessionInfo.toObject, includeInstance),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMRecentContactSessionRsp;
    return proto.IM.Buddy.IMRecentContactSessionRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMRecentContactSessionRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = new IM_BaseDefine_pb.ContactSessionInfo;
                reader.readMessage(value, IM_BaseDefine_pb.ContactSessionInfo.deserializeBinaryFromReader);
                msg.addContactSessionList(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMRecentContactSessionRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMRecentContactSessionRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRecentContactSessionRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getContactSessionListList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, IM_BaseDefine_pb.ContactSessionInfo.serializeBinaryToWriter);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp} returns this
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated IM.BaseDefine.ContactSessionInfo contact_session_list = 2;
 * @return {!Array<!proto.IM.BaseDefine.ContactSessionInfo>}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.getContactSessionListList = function() {
    return /** @type{!Array<!proto.IM.BaseDefine.ContactSessionInfo>} */ jspb.Message.getRepeatedWrapperField(this, IM_BaseDefine_pb.ContactSessionInfo, 2);
};
/**
 * @param {!Array<!proto.IM.BaseDefine.ContactSessionInfo>} value
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp} returns this
*/ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.setContactSessionListList = function(value) {
    return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.IM.BaseDefine.ContactSessionInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IM.BaseDefine.ContactSessionInfo}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.addContactSessionList = function(opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.IM.BaseDefine.ContactSessionInfo, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp} returns this
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.clearContactSessionListList = function() {
    return this.setContactSessionListList([]);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp} returns this
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Buddy.IMRecentContactSessionRsp} returns this
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMRecentContactSessionRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMUserStatNotify.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMUserStatNotify.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMUserStatNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMUserStatNotify.toObject = function(includeInstance, msg) {
        var f, obj = {
            userStat: (f = msg.getUserStat()) && IM_BaseDefine_pb.UserStat.toObject(includeInstance, f)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMUserStatNotify}
 */ proto.IM.Buddy.IMUserStatNotify.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMUserStatNotify;
    return proto.IM.Buddy.IMUserStatNotify.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMUserStatNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMUserStatNotify}
 */ proto.IM.Buddy.IMUserStatNotify.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new IM_BaseDefine_pb.UserStat;
                reader.readMessage(value, IM_BaseDefine_pb.UserStat.deserializeBinaryFromReader);
                msg.setUserStat(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMUserStatNotify.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMUserStatNotify.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMUserStatNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMUserStatNotify.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserStat();
    if (f != null) {
        writer.writeMessage(1, f, IM_BaseDefine_pb.UserStat.serializeBinaryToWriter);
    }
};
/**
 * optional IM.BaseDefine.UserStat user_stat = 1;
 * @return {?proto.IM.BaseDefine.UserStat}
 */ proto.IM.Buddy.IMUserStatNotify.prototype.getUserStat = function() {
    return /** @type{?proto.IM.BaseDefine.UserStat} */ jspb.Message.getWrapperField(this, IM_BaseDefine_pb.UserStat, 1);
};
/**
 * @param {?proto.IM.BaseDefine.UserStat|undefined} value
 * @return {!proto.IM.Buddy.IMUserStatNotify} returns this
*/ proto.IM.Buddy.IMUserStatNotify.prototype.setUserStat = function(value) {
    return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Buddy.IMUserStatNotify} returns this
 */ proto.IM.Buddy.IMUserStatNotify.prototype.clearUserStat = function() {
    return this.setUserStat(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMUserStatNotify.prototype.hasUserStat = function() {
    return jspb.Message.getField(this, 1) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMRemoveSessionReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMRemoveSessionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRemoveSessionReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            sessionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            sessionId: jspb.Message.getFieldWithDefault(msg, 3, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMRemoveSessionReq}
 */ proto.IM.Buddy.IMRemoveSessionReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMRemoveSessionReq;
    return proto.IM.Buddy.IMRemoveSessionReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMRemoveSessionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMRemoveSessionReq}
 */ proto.IM.Buddy.IMRemoveSessionReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.SessionType} */ reader.readEnum();
                msg.setSessionType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSessionId(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMRemoveSessionReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMRemoveSessionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRemoveSessionReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getSessionType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getSessionId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionReq} returns this
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional IM.BaseDefine.SessionType session_type = 2;
 * @return {!proto.IM.BaseDefine.SessionType}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.getSessionType = function() {
    return /** @type {!proto.IM.BaseDefine.SessionType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.SessionType} value
 * @return {!proto.IM.Buddy.IMRemoveSessionReq} returns this
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.setSessionType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional uint32 session_id = 3;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.getSessionId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionReq} returns this
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Buddy.IMRemoveSessionReq} returns this
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Buddy.IMRemoveSessionReq} returns this
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMRemoveSessionReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMRemoveSessionRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMRemoveSessionRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRemoveSessionRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            resultCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
            sessionType: jspb.Message.getFieldWithDefault(msg, 3, 0),
            sessionId: jspb.Message.getFieldWithDefault(msg, 4, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp}
 */ proto.IM.Buddy.IMRemoveSessionRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMRemoveSessionRsp;
    return proto.IM.Buddy.IMRemoveSessionRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMRemoveSessionRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp}
 */ proto.IM.Buddy.IMRemoveSessionRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setResultCode(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.BaseDefine.SessionType} */ reader.readEnum();
                msg.setSessionType(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSessionId(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMRemoveSessionRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMRemoveSessionRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRemoveSessionRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getResultCode();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getSessionType();
    if (f !== 0.0) {
        writer.writeEnum(3, f);
    }
    f = message.getSessionId();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp} returns this
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 result_code = 2;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getResultCode = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp} returns this
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional IM.BaseDefine.SessionType session_type = 3;
 * @return {!proto.IM.BaseDefine.SessionType}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getSessionType = function() {
    return /** @type {!proto.IM.BaseDefine.SessionType} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.BaseDefine.SessionType} value
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp} returns this
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.setSessionType = function(value) {
    return jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional uint32 session_id = 4;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getSessionId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp} returns this
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp} returns this
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Buddy.IMRemoveSessionRsp} returns this
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMRemoveSessionRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Buddy.IMUsersStatReq.repeatedFields_ = [
    2
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMUsersStatReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMUsersStatReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMUsersStatReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            userIdListList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMUsersStatReq}
 */ proto.IM.Buddy.IMUsersStatReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMUsersStatReq;
    return proto.IM.Buddy.IMUsersStatReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMUsersStatReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMUsersStatReq}
 */ proto.IM.Buddy.IMUsersStatReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++){
                    msg.addUserIdList(values[i]);
                }
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMUsersStatReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMUsersStatReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMUsersStatReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getUserIdListList();
    if (f.length > 0) {
        writer.writePackedUint32(2, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMUsersStatReq} returns this
 */ proto.IM.Buddy.IMUsersStatReq.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated uint32 user_id_list = 2;
 * @return {!Array<number>}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.getUserIdListList = function() {
    return /** @type {!Array<number>} */ jspb.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.IM.Buddy.IMUsersStatReq} returns this
 */ proto.IM.Buddy.IMUsersStatReq.prototype.setUserIdListList = function(value) {
    return jspb.Message.setField(this, 2, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.IM.Buddy.IMUsersStatReq} returns this
 */ proto.IM.Buddy.IMUsersStatReq.prototype.addUserIdList = function(value, opt_index) {
    return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Buddy.IMUsersStatReq} returns this
 */ proto.IM.Buddy.IMUsersStatReq.prototype.clearUserIdListList = function() {
    return this.setUserIdListList([]);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Buddy.IMUsersStatReq} returns this
 */ proto.IM.Buddy.IMUsersStatReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Buddy.IMUsersStatReq} returns this
 */ proto.IM.Buddy.IMUsersStatReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMUsersStatReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Buddy.IMUsersStatRsp.repeatedFields_ = [
    2
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMUsersStatRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMUsersStatRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMUsersStatRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            userStatListList: jspb.Message.toObjectList(msg.getUserStatListList(), IM_BaseDefine_pb.UserStat.toObject, includeInstance),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMUsersStatRsp}
 */ proto.IM.Buddy.IMUsersStatRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMUsersStatRsp;
    return proto.IM.Buddy.IMUsersStatRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMUsersStatRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMUsersStatRsp}
 */ proto.IM.Buddy.IMUsersStatRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = new IM_BaseDefine_pb.UserStat;
                reader.readMessage(value, IM_BaseDefine_pb.UserStat.deserializeBinaryFromReader);
                msg.addUserStatList(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMUsersStatRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMUsersStatRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMUsersStatRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getUserStatListList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(2, f, IM_BaseDefine_pb.UserStat.serializeBinaryToWriter);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMUsersStatRsp} returns this
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated IM.BaseDefine.UserStat user_stat_list = 2;
 * @return {!Array<!proto.IM.BaseDefine.UserStat>}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.getUserStatListList = function() {
    return /** @type{!Array<!proto.IM.BaseDefine.UserStat>} */ jspb.Message.getRepeatedWrapperField(this, IM_BaseDefine_pb.UserStat, 2);
};
/**
 * @param {!Array<!proto.IM.BaseDefine.UserStat>} value
 * @return {!proto.IM.Buddy.IMUsersStatRsp} returns this
*/ proto.IM.Buddy.IMUsersStatRsp.prototype.setUserStatListList = function(value) {
    return jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.IM.BaseDefine.UserStat=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IM.BaseDefine.UserStat}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.addUserStatList = function(opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.IM.BaseDefine.UserStat, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Buddy.IMUsersStatRsp} returns this
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.clearUserStatListList = function() {
    return this.setUserStatListList([]);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Buddy.IMUsersStatRsp} returns this
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Buddy.IMUsersStatRsp} returns this
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Buddy.IMUsersStatRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMPCLoginStatusNotify.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMPCLoginStatusNotify.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMPCLoginStatusNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMPCLoginStatusNotify.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            loginStat: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMPCLoginStatusNotify}
 */ proto.IM.Buddy.IMPCLoginStatusNotify.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMPCLoginStatusNotify;
    return proto.IM.Buddy.IMPCLoginStatusNotify.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMPCLoginStatusNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMPCLoginStatusNotify}
 */ proto.IM.Buddy.IMPCLoginStatusNotify.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.UserStatType} */ reader.readEnum();
                msg.setLoginStat(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMPCLoginStatusNotify.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMPCLoginStatusNotify.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMPCLoginStatusNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMPCLoginStatusNotify.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getLoginStat();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMPCLoginStatusNotify.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMPCLoginStatusNotify} returns this
 */ proto.IM.Buddy.IMPCLoginStatusNotify.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional IM.BaseDefine.UserStatType login_stat = 2;
 * @return {!proto.IM.BaseDefine.UserStatType}
 */ proto.IM.Buddy.IMPCLoginStatusNotify.prototype.getLoginStat = function() {
    return /** @type {!proto.IM.BaseDefine.UserStatType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.UserStatType} value
 * @return {!proto.IM.Buddy.IMPCLoginStatusNotify} returns this
 */ proto.IM.Buddy.IMPCLoginStatusNotify.prototype.setLoginStat = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Buddy.IMRemoveSessionNotify.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Buddy.IMRemoveSessionNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRemoveSessionNotify.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            sessionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            sessionId: jspb.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Buddy.IMRemoveSessionNotify}
 */ proto.IM.Buddy.IMRemoveSessionNotify.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Buddy.IMRemoveSessionNotify;
    return proto.IM.Buddy.IMRemoveSessionNotify.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Buddy.IMRemoveSessionNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Buddy.IMRemoveSessionNotify}
 */ proto.IM.Buddy.IMRemoveSessionNotify.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.SessionType} */ reader.readEnum();
                msg.setSessionType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSessionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Buddy.IMRemoveSessionNotify.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Buddy.IMRemoveSessionNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Buddy.IMRemoveSessionNotify.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getSessionType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getSessionId();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionNotify} returns this
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional IM.BaseDefine.SessionType session_type = 2;
 * @return {!proto.IM.BaseDefine.SessionType}
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.getSessionType = function() {
    return /** @type {!proto.IM.BaseDefine.SessionType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.SessionType} value
 * @return {!proto.IM.Buddy.IMRemoveSessionNotify} returns this
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.setSessionType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional uint32 session_id = 3;
 * @return {number}
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.getSessionId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Buddy.IMRemoveSessionNotify} returns this
 */ proto.IM.Buddy.IMRemoveSessionNotify.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
goog.object.extend(exports, proto.IM.Buddy);

})();

export default module.exports;
